import API from "../http-common";

import { debugLog } from "../utils/debugUtils";

const getAll = () => {
	return API.get("/usergroups");
};

const get = (id) => {
	return API.get(`/usergroups/${id}`);
};

const create = (data) => {
	return API.post("/usergroups", data);
};

const update = (id, data) => {
	return API.put(`/usergroups/${id}`, data);
};

const findByKeyword = (keyword) => {
	return API.get(`/usergroups?kw=${keyword}`);
};

const UserGroupService = {
	getAll,
	get,
	create,
	update,
	findByKeyword,
};

export default UserGroupService;
